import { render, staticRenderFns } from "./Topimage.vue?vue&type=template&id=1caaf663&scoped=true"
import script from "./Topimage.vue?vue&type=script&lang=js"
export * from "./Topimage.vue?vue&type=script&lang=js"
import style0 from "./Topimage.vue?vue&type=style&index=0&id=1caaf663&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caaf663",
  null
  
)

export default component.exports